<template>
  <div class="app">
    <Snackbar :text="text" :snackbar="snackbar" @change="snackbar = $event" />
    <v-sheet v-show="showSkeleton" class="pa-3">
      <v-row>
        <v-col v-for="item in 2" :key="item">
          <v-skeleton-loader class="mx-auto" type="list-item" />
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-skeleton-loader class="mx-auto" type="button" />
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-skeleton-loader class="mx-auto" type="image" height="220" />
        </v-col>
      </v-row>
    </v-sheet>
    <v-form ref="form" v-show="!showSkeleton">
      <v-row>
        <v-col cols="6">
          <v-text-field
            dense
            :value="form.description.toUpperCase()"
            :error-messages="descriptionErrors"
            :counter="30"
            label="Nome"
            outlined
            @input="
              $v.form.description.$touch()
              form.description = $event.toUpperCase().trim()
            "
            @blur="$v.form.description.$touch()"
          />
        </v-col>
        <v-col cols="6">
          <v-text-field
            dense
            v-model="form.canais"
            :error-messages="canaisErrors"
            :counter="60"
            label="String"
            outlined
            @input="
              $v.form.canais.$touch()
              form.canais = $event.trim()
            "
            @blur="$v.form.canais.$touch()"
          />
        </v-col>
      </v-row>
      <v-checkbox dense v-model="form.interno" label="Interno" />
      <DraggAndDrop
        v-if="!form.interno"
        dragname="Rotas"
        :valoresDisponiveisComboBox="rotasGerais.rotasGeralDisponiveis"
        @dragUpdate="updateRotasGeral($event)"
        :opcoesSelecionadas="rotasGerais.rotasGeralSelecionadas"
      />

      <v-divider dark vertical />
      <v-divider dark />
      <v-divider dark vertical />
      <FixedButtons @salvar="salvar" @cancelar="cancelar" :pararLoader="pararLoader" />
    </v-form>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { validationMixin } from 'vuelidate'
import Snackbar from '@/componentes/Snackbar'
import FixedButtons from '@/componentes/FixedButtons'
import { registerVuexModule, formatarRota } from '@/utils/vuexUtils'
import { ordenar } from '@/utils/ordenarArrayByText'
import DraggAndDrop from '../_components/DraggAndDrop'
import troncosStore from '../_store'
import { validateData, validateComputed } from '../_validates/validateKhomp'
import TroncosHttpService from '../_services/TroncosHttpService'

export default {
  name: 'AbaTronoKhomp',
  props: {
    edicao: String,
    _id: String,
  },
  components: { Snackbar, DraggAndDrop, FixedButtons },
  mixins: [validationMixin],
  data: () => ({
    form: {
      description: '',
      tipo: 'KHOMP',
      canais: '',
      interno: false,
      rota: [],
    },
    rotasGerais: {
      rotasGeralDisponiveis: [],
      rotasGeralSelecionadas: [],
    },
    text: '',
    snackbar: false,
    showSkeleton: true,
    pararLoader: {
      parar: false,
    },
  }),

  validations: {
    ...validateData,
  },

  computed: {
    ...mapGetters('abaTroncoKhompModulePABXStore', ['getRotasDisponiveis', 'getTroncoSelecionado']),
    ...validateComputed,
  },

  async created() {
    registerVuexModule(this.$store, 'abaTroncoKhompModulePABXStore', troncosStore)

    await this.listarRotas()

    this.rotasGerais.rotasGeralDisponiveis = [...this.getRotasDisponiveis]

    if (this.edicao === 'true') {
      this.form = this.getTroncoSelecionado

      const arrayrotasSelecionadas = Object.values(this.getTroncoSelecionado.rota)

      arrayrotasSelecionadas.forEach(rotasSelecionadas => {
        const indexRotaGeral = this.rotasGerais.rotasGeralDisponiveis.findIndex(
          rotaGeral => rotaGeral._id === rotasSelecionadas
        )

        if (indexRotaGeral !== -1) {
          this.rotasGerais.rotasGeralSelecionadas.push(this.rotasGerais.rotasGeralDisponiveis[indexRotaGeral])
        }
      })
    } else {
      this.rotasGerais.rotasGeralSelecionadas = this.getRotasDisponiveis.filter(rota => rota.default)
    }

    ordenar(this.rotasGerais.rotasGeralDisponiveis)
    this.showSkeleton = false
  },

  methods: {
    ...mapActions('abaTroncoKhompModulePABXStore', ['listarRotas']),
    updateRotasGeral(event) {
      this.form.rota = formatarRota(event)
    },
    async salvar() {
      this.pararLoader.parar = false

      if (!this.form.rota['1']) {
        this.text = 'Nenhuma rota selecionada.'
        this.snackbar = true
        this.pararLoader.parar = true
        return
      }

      this.$v.$touch()
      if (this.$v.$error) {
        this.$vuetify.goTo(1, { duration: 1000, easing: 'easeOutCubic' })
        this.pararLoader.parar = true
        return
      }
      try {
        if (this.edicao === 'true') {
          delete this.form.numero
          await TroncosHttpService.putTronco(this.form)
        } else {
          await TroncosHttpService.postTronco(this.form)
        }
        this.$router.push({ name: 'Troncos' })
      } catch (error) {
        this.text = error.response.data
        this.snackbar = true
        this.pararLoader.parar = true
      }
    },
    cancelar() {
      this.$router.push({ name: 'Troncos' })
    },
  },
}
</script>

<style scoped>
.app {
  background-color: var(--v-background-base);
}
</style>
